export default __webpack_public_path__ + "static/event-graphia-dropped-eaaa3c4c8e2ea6c5b6738a8267ed9283.jpg";